import * as React from "react";
import {getBrowserLocationPath} from "../../api/BrowserWrapper";
import SubNav from "../base/SubNav.component";
import {
    hasHoldings,
    investmentsEnabled,
    portfolioProductSummariesSelector,
    userType
} from "../../../mainReducerMapSelectors";
import {useDispatch, useSelector} from "react-redux";
import {showInvestments} from "../../utils/navigationUtils";
import {getSuccessData} from "../common/commonStates";
import {useEffect} from "react";
import {getPortfolioProductSummaries} from "../product/AllProductsActions";
import {useNavigate} from "react-router-dom";
import {navigateTo} from "../../../navigateTo";
import {IApplicationRootState} from "../../../applicationState";
import {AnyThunkDispatch} from "../../../commonTypes";

export enum PortfolioNavItems {
    INVESTMENTS = "investments",
    PORTFOLIO = "portfolio",
}

export const PortfolioNav: React.FunctionComponent = () => {
    const hasHoldingsAccess = useSelector((state: IApplicationRootState) => hasHoldings(state));
    const hasInvestmentsEnabled = useSelector((state: IApplicationRootState) => investmentsEnabled(state));
    const currentUserType = useSelector((state: IApplicationRootState) => userType(state));
    const portfolioProductSummaries =
        useSelector((state: IApplicationRootState) => getSuccessData(portfolioProductSummariesSelector(state)));

    const navigate = useNavigate();
    const dispatch: AnyThunkDispatch = useDispatch();
    useEffect(() => {
        if (!portfolioProductSummaries) {
            dispatch(getPortfolioProductSummaries);
        }
    }, []);

    const portfolioNavItem = {
        id: PortfolioNavItems.PORTFOLIO,
        name: "Portfolio",
    };

    const investmentsNavItem = {
        id: PortfolioNavItems.INVESTMENTS,
        name: "Investments",
    };

    function isSelected(id: string) {
        return getBrowserLocationPath()?.includes(`${id}`);
    }

    function getMenuItems() {
        const items = [];

        if (showInvestments(hasHoldingsAccess, currentUserType, hasInvestmentsEnabled)) {
            items.push(investmentsNavItem);
        }
        items.push(portfolioNavItem);

        return items;
    }

    function isPortfolioUrl() {
        return ["managers", "products", "portfolio"].find((item) => getBrowserLocationPath().includes(item));
    }

    function getSelectedMenuItem() {
        return isPortfolioUrl()
                ? portfolioNavItem.id
                : getMenuItems()
                    .map((item) => item.id)
                    .find(isSelected);
    }

    function selectNavItem(id: string) {
        const selectedItem = findMenuItem(id);
        navigateTo(`/${selectedItem.id}`, navigate);
    }

    function findMenuItem(id: string) {
        return getMenuItems().find((item) => item.id.toString() === id)!;
    }

    return <SubNav
        menuItems={getMenuItems()}
        searchEnabled={false}
        onItemSelected={selectNavItem}
        selectedMenuItem={getSelectedMenuItem()}
    />;
};
